import styled, { css } from 'styled-components';

export const Page = styled.div<{ $userThemeEnabled?: boolean }>`
  height: 100vh;
  max-height: 100%;
  width: 100vw;
  max-width: 100%;
  overflow: hidden;
  background-color: rgb(235, 235, 235);
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $userThemeEnabled }) =>
    $userThemeEnabled &&
    css`
      @media (prefers-color-scheme: dark) {
        background-color: rgb(30, 30, 30);
      }

      @media (forced-colors: active) {
        background-color: #16141d;
      }
    `}
`;

export const Container = styled.div<{ $userThemeEnabled?: boolean }>`
  background-color: #ffffff;
  border-radius: 16px;
  border-color: rgb(255, 255, 255);
  border-style: solid;
  border-width: 1px;
  box-shadow: rgb(33 33 33 / 20%) 0px 1px 4px 1px;
  display: flex;
  flex-direction: column;
  padding: 35px 50px 45px;
  margin-bottom: 30px;
  height: 100%;
  width: 100%;
  max-width: 100%;
  line-height: 24px;

  ${({ $userThemeEnabled }) =>
    $userThemeEnabled &&
    css`
      @media (prefers-color-scheme: dark) {
        background-color: #212121;
        border-color: #525252;
        box-shadow: rgb(0 0 0 / 40%) 0px 1px 4px 1px;
      }

      @media (forced-colors: active) {
        background-color: #16141d;
        border-color: #adadad;
        border-width: 2px;
        box-shadow: rgb(0 0 0 / 40%) 0px 1px 4px 1px;
      }
    `}
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const SkeletonItem = styled.div<{
  height: string;
  width: string;
  marginBottom?: string;
  $userThemeEnabled?: boolean;
}>`
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  ${({ marginBottom }) => marginBottom && `margin-bottom: ${marginBottom};`}

  ${({ $userThemeEnabled }) =>
    $userThemeEnabled &&
    css`
      @media (prefers-color-scheme: dark) {
        background-color: #3d3d3d40;
        position: relative;
        overflow: hidden;
        border-radius: 8px;
      }

      @media (forced-colors: active) {
        forced-color-adjust: none;
        background-color: #52525240;
        position: relative;
        overflow: hidden;
        border-radius: 8px;
      }
    `}
`;
